import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        cardContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '20px 0',
        },
        cardBorder: {
            color: themes.palette.primary.main,
            width: '90%',
            border: `1px solid ${themes.palette.grey['200']}`,
        },
        accountCard: {
            color: themes.palette.primary.main,
            width: '90%',
        },
        cardTop: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        cardTopLeft: {
            display: 'flex',
            alignItems: 'center',
        },
        accountTitle: {
            fontSize: 18,
            margin: 0,
            fontFamily: 'Graphik',
            fontWeight: 'bold',
        },
        accountIcon: {
            marginRight: 7,
        },
        accountDetails: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        accountSubTitle: {
            fontSize: 12,
            fontWeight: 300,
            margin: 0,
            fontFamily: 'PoppinsRegular',
        },
        connectButton: {
            borderRadius: 42,
            padding: '7px 12px',
            border: 'none',
            background: themes.palette.primary.main,
            color: themes.palette.common.white,
            fontSize: 13,
            '&:disabled': {
                color: themes.palette.grey['400'],
                background: themes.palette.grey['200'],
            },
            textTransform: 'uppercase',
        },
        disConnectButton: {
            border: '1px solid #FFFFFF',
            borderRadius: 42,
            padding: '8px 12px',
            background: 'none',
            color: themes.palette.primary.main,
            fontSize: 13,
            textTransform: 'uppercase',
        },
        cardBottom: {
            '& p': {
                fontSize: 12,
                fontWeight: 300,
                marginTop: 10,
                marginBottom: 0,
                fontFamily: 'PoppinsRegular',
            },
        },
        loadingSection: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        loadingText: {
            color: themes.palette.primary.main,
            fontWeight: 'bold',
        },
    }),
);
